module.exports = __webpack_public_path__ + "img/credit.61b1f0bc.png";